import { BaseEntity, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'serving-tool',
})
export default class ServingTool extends BaseEntity {
  name: string = '';

  public constructor(id?: string) {
    super();
    this.id = id;
  }
}
